import { observer } from "mobx-react-lite";
import { useState } from "react";

import { DateTime } from "@bps/date-time";
import { Card, DefaultButton, Stack } from "@bps/fluent-ui";
import { XeroFinancialSyncStatus } from "@libs/gateways/custom-integration/CustomIntegrationXeroGateway.dtos.ts";
import { DataFetcher } from "@ui-components/data-fetcher/DataFetcher.tsx";

import { useIntegrationScreenContext } from "../context/IntegrationScreenContext.ts";
import { XeroSyncHistoryHeading } from "./XeroSyncHistoryHeading.tsx";
import { XeroSyncHistoryList } from "./XeroSyncHistoryList.tsx";

export const XeroSyncHistoryCard = observer(() => {
  const { xeroTenantId, showXeroConfigurationCard, xeroTenants } =
    useIntegrationScreenContext();

  const [refetchId, setRefetchId] = useState<string>();
  const [showAll, setShowAll] = useState(false);

  const refreshList = () => {
    setRefetchId(DateTime.now().toISO());
  };

  if (!xeroTenantId || !showXeroConfigurationCard || xeroTenants.length === 0)
    return null;

  return (
    <Card
      heading={<XeroSyncHistoryHeading />}
      styles={{
        heading: { width: "100%" },
        subComponentStyles: {
          tile: {
            content: { padding: 24 }
          }
        }
      }}
    >
      <DataFetcher
        refetchId={refetchId}
        fetch={root =>
          root.customIntegrationXero.getFinancialSyncData({
            statuses: showAll
              ? undefined
              : [
                  XeroFinancialSyncStatus.Warnings,
                  XeroFinancialSyncStatus.Errors,
                  XeroFinancialSyncStatus.InternalFailure
                ]
          })
        }
      >
        {data => (
          <>
            <Stack
              horizontal
              tokens={{ childrenGap: 20 }}
              horizontalAlign="end"
            >
              <DefaultButton onClick={refreshList}>Refresh</DefaultButton>
              <DefaultButton
                onClick={() => {
                  setShowAll(!showAll);
                  refreshList();
                }}
              >
                {showAll ? "Show only errors" : "Show all"}
              </DefaultButton>
            </Stack>
            <XeroSyncHistoryList data={data} />
          </>
        )}
      </DataFetcher>
    </Card>
  );
});
